<template>
  <div>
    <section class="section position-relative">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
            <accountMenu />
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="title">Bank Account</h3>
            </div>

            <p class="border-bottom-cus mt-2"></p>
            <p>Setup bank account for withdraw</p>
            <template v-if="!hasSetup">
              <b-alert show variant="warning">
                <h5 class="alert-heading">Empty bank account.</h5>
                <p>
                  You can not withdraw from this account until setup bank
                  account
                </p>
              </b-alert>
            </template>
            <template v-if="model.last_digits != ''">
              <b-alert show variant="light">
                <h5 class="alert-heading">
                  Current account no. last four digits is
                  {{ model.last_digits }}
                  <template v-if="accountVerified">
                    <b-badge variant="success">Verified</b-badge>
                  </template>
                  <template v-else>
                    <b-badge variant="warning">Wating</b-badge>
                  </template>
                </h5>
                <p>
                  If you want to change account no. or update information then
                  enter detail and save changes then wait 1-2 days to verify
                  again.
                </p>
              </b-alert>
            </template>
            <div class="table-responsive bg-white">
              <b-form
                ref="form"
                @submit.stop.prevent="onSubmit"
                novalidate
                :validated="formValid"
              >
                <b-container fluid class="mt-0">
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-group label="Bank:" class="mb-0">
                        <b-form-select
                          required
                          v-model="model.selectedBank"
                          :options="banks"
                          value-field="code"
                        >
                          <template #first>
                            <b-form-select-option :value="null" disabled
                              >-- Please select a bank --</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group :label="`Account Number:`" class="mb-0">
                        <b-form-input
                          v-model="model.accountNo"
                          :required="!hasSetup"
                          placeholder="Enter account number"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group label="Account Name:" class="mb-0">
                        <b-form-input
                          v-model="model.accountName"
                          required
                          placeholder="Enter bank account name"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-group label="Description:" class="mb-0">
                        <b-form-input
                          v-model="model.desc"
                          placeholder="Enter description"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div class="mt-4">
                    <b-button variant="primary" type="submit"
                      >Save Changes</b-button
                    >
                  </div>
                </b-container>
              </b-form>
            </div>
          </div>
        </div>
      </div>

      <b-overlay :show="overlay" no-wrap> </b-overlay>
    </section>
  </div>
</template>

<script>
import accountMenu from "@/views/account/menu.vue";
import bankService from "../../../services/bankAccount";
export default {
  components: {
    accountMenu,
  },
  data: () => ({
    hasSetup: false,
    accountVerified: false,
    formValid: false,
    banks: [],
    currentAccount: null,
    model: {
      selectedBank: null,
      accountNo: "",
      accountName: "",
      desc: "",
      last_digits: "",
    },
    overlay: false,
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.overlay = true;
      bankService.getBankList().then((resp) => {
        this.banks = resp.data;
        this.getCurrentAccount();
      });
    },
    getCurrentAccount() {
      bankService
        .getBankAccount()
        .then((resp) => {
          if (resp.data.length > 0) {
            this.hasSetup = true;
            const currentBank = resp.data[0];
            if (currentBank.verified === true && currentBank.active === true) {
              this.accountVerified = true;
            } else {
              this.accountVerified = false;
            }

            this.model.selectedBank = currentBank.bank_account.bank_code;
            this.model.accountNo = "";
            this.model.accountName = currentBank.bank_account.name;
            this.model.desc = currentBank.description;
            this.model.last_digits = currentBank.bank_account.last_digits;

            this.currentAccount = currentBank;
          } else {
            // not setup yet
            this.currentAccount = null;
            this.hasSetup = false;
            this.accountVerified = false;
          }
        })
        .catch((err) => {
          // do nothing
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    addOrUpdateBankAccount() {
      // generate data
      let data = {
        name: this.model.accountName,
        description: this.model.desc,
        bank_account: {
          name: this.model.accountName,
          number: this.model.accountNo,
          bank_code: this.model.selectedBank,
        },
      };

      if (this.hasSetup == true) {
        if (this.model.accountNo == null || this.model.accountNo == "") {
          delete data.bank_account.number;
        }
        return bankService.updateBankAccount(this.currentAccount.id, data);
      } else {
        return bankService.addBankAccount(data);
      }
    },
    validateState(fieldName) {
      if (this.$data.hasOwnProperty(fieldName)) {
        let val = this.$data[fieldName];
        if (val == null || val == "") {
          return false;
        } else {
          return true;
        }
      }
      return null;
    },
    onSubmit() {
      this.formValid = true;
      let formPass = this.$refs.form.checkValidity();
      if (formPass) {
        this.overlay = true;
        this.addOrUpdateBankAccount()
          .then((resp) => {
            console.log(resp.data);
            if (resp.data == true) {
              this.getCurrentAccount();
              this.formValid = false;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            // do something
            this.overlay = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.border-bottom-cus {
  border-bottom: 5px solid !important;
  color: rgba(0, 201, 167, 0.1);
}
</style>